import React, { useContext } from "react";
import styled from "styled-components";
import { GameEventsContext } from "../../contexts/GameEventContext";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function ZonesOfControl({
  component,
  game,
  homeScorers,
  awayScorers,
  previewGraphic,
  period,
}) {
  const { processedFirstEvent, processedSecondEvent } =
    useContext(GameEventsContext);
  return (
    <GraphicButton
      onClick={() => {
        previewGraphic("LTZonesOfControl", {
          game: {
            ...game,
            home_scorers: homeScorers,
            away_scorers: awayScorers,
          },
          period,
          events:
            period.number === 1 ? processedFirstEvent : processedSecondEvent,
        });
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default ZonesOfControl;
